import { Epic } from 'redux-observable';
import { catchError, debounceTime, map, switchMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import { ofType } from '@alycecom/utils';

import { meetingSlotsRequest, meetingSlotsSuccess, meetingSlotsFail } from './meeting.actions';
import { getAutoDetect, getWeek } from './meeting.selectors';
import { IMeetingResponse } from './meeting.types';

export const meetingWeekSlotsEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(meetingSlotsRequest),
    debounceTime(300),
    withLatestFrom(state$),
    switchMap(
      ([
        {
          payload: { hashId },
        },
        state,
      ]) => {
        const autoDetect = getAutoDetect(state);
        const { from, to } = getWeek(state);
        return apiService
          .get(`/api/recipient/${hashId}/calendar/slots?from=${from}&to=${to}&autodetect=${autoDetect}`)
          .pipe(
            map((payload: IMeetingResponse) => meetingSlotsSuccess(payload)),
            catchError(errorHandler({ callbacks: meetingSlotsFail })),
            takeUntil(action$.ofType(meetingSlotsRequest)),
          );
      },
    ),
  );

export const meetingEpics = [meetingWeekSlotsEpic];
